import { useState } from "react";
import { useScrollLock } from "./useScrollLock";

export const useContactModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useScrollLock(isOpen);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    openModal,
    closeModal,
  };
};

export default useContactModal;
